import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { ClaimFullBO } from './cliam-edit.model';

@Injectable({
  providedIn: 'root'
})

export class ClaimEditService {

  constructor(private http: HttpClient, public errorService: ErrorService) { }

  getEditClaimDetail(params: URLSearchParams): Observable<any> {
    let url = "api/Claims/getClaim?";
    return this.http.get<any>(url + params, { observe: "response" }).pipe(
      map((data) => data.body),
      catchError(this.errorService.handleError)
    );
  }
  
  saveEditClaim(editcliam: ClaimFullBO): Observable<any> {
    let url = "api/Claims/updateClaimBill";
    return this.http.post(url, editcliam, { observe: "response", responseType: "text" }).pipe(
      map((data) => data.body),
      catchError(this.errorService.handleError)
    );
  }

  saveorUpdateFunctionwithResponseTypeJson(saveList, url): Observable<any> {
    return this.http.post(url, saveList, { observe: 'response' }).pipe(
        map(data => data.body),
        catchError(this.errorService.handleError)
    )
}

GetFunctionwithResponseTypeJson(params, url): Observable<any> {
  return this.http.get(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
  );
}
}
